// extracted by mini-css-extract-plugin
export default {"save-btn":"resellers_save-btn__kGAcf","add-button":"resellers_add-button__nAKAx","row-click":"resellers_row-click__vGGdq","subreseller-data":"resellers_subreseller-data__WksSp"};